export default "__VITE_ASSET__CKjOIi66__"